import React, { useContext, useEffect } from 'react';
import '../components_styles/Homepage.css';
import spotifyLogo from '../img/spotify_logo.png';
import gitHub from '../img/github.png';
import FadeIn from 'react-fade-in';
import { AuthContext } from 'react-oauth2-code-pkce';
import Cookies from 'js-cookie';

function Homepage() {
  const { logIn, token, loginInProgress } = useContext(AuthContext);

  useEffect(() => {
    if (token) {
      Cookies.set('spotifyAuthToken', token, { expires: 1 });
      window.location.replace('/select');
    }
  }, [token]);

  return (
    <div className='Home'>
      <div className='homepage-header'>
        <FadeIn delay={100} transitionDuration={600}>
          <div className='main-home-div'>
            <h1>Wrapify</h1>
            <img src={spotifyLogo} alt='logo'></img>
          </div>
          <div className='secondary-header-container'>
            <p>view your top <span className='green-spotify-callout'>Spotify</span> jams at any time</p>
          </div>
          <div className='spotify-auth-container'>
            <button className='rsaSpotifyBtn' onClick={() => logIn()} disabled={loginInProgress}>
              {loginInProgress ? 'Logging in...' : 'Login with Spotify'}
            </button>
          </div>
        </FadeIn>
      </div>
      <div className='footer-home'>
        <p><a target='_blank' rel='noopener noreferrer' href='https://github.com/tommydamiano'>Developed by Tommy Damiano</a></p>
        <img src={gitHub} alt='github'></img>
      </div>
    </div>
  );
}

export default Homepage;
